/** Labels aligned to column indices from `buildColumnsFromRows` (0=last, 1=this, 2=next). */
export const WEEK_COLUMN_LABELS = ['Last week', 'This week', 'Next week'] as const;

/** Toggle options shown in the UI (this week + next week only). */
export const WEEK_TABS = [
  { index: 1, label: 'This week' },
  { index: 2, label: 'Next week' },
] as const;

export function weekTabLabel(index: number): string {
  return WEEK_COLUMN_LABELS[index] ?? `Week ${index + 1}`;
}
